<template>
  <div :class="classes()">
    <div :class="`${el}__content`">
      <Copy element="div" size="l" bold>{{ headline }}</Copy>
      <Copy element="div" :staticClass="`${el}__copy`" color="tertiaryLight">
        {{ copy }}
      </Copy>
    </div>
    <div :class="`${el}__button`">
      <Link
        v-if="href"
        :to="href"
        :external="external"
        :externalIcon="false"
        :onClick="clickOnTeaserLink"
      >
        {{ button.label }}
      </Link>
      <Button v-else v-bind="button" small type="outlined" />
    </div>
  </div>
</template>

<script>
import Copy from '@/objects/Copy';
import Link from '@/objects/Link';
import Button from '@/objects/Button';

export default {
  name: 'SimpleTeaser',
  components: {
    Copy,
    Link,
    Button,
  },
  props: {
    headline: String,
    copy: String,
    button: {
      text: String,
      onClick: Function,
    },
    clickOnTeaserLink: Function,
    background: {
      type: String,
      default: 'secondaryMint',
      validator: (val) => ['secondaryMint', 'secondaryRose'].includes(val),
    },
    direction: {
      type: String,
      default: 'vertical',
      validator: (val) => ['vertical', 'horizontal'].includes(val),
    },
    external: Boolean,
    href: String,
  },
  data() {
    return {
      el: 'c-simpleTeaser',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--${this.direction}`]: this.direction,
          [`${el}--${this.background}`]: this.background,
        };
      },
    };
  },
};
</script>
